import { not, readOnly } from '@ember/object/computed';
import Service, { inject as service } from '@ember/service';
import { computed } from '@ember/object';
import { matchMedia } from '@square/glass-ui/utils/window';

// eslint-disable-next-line ember/no-classic-classes
export default Service.extend({
  userInfo: service(),
  mobileQueryIsActive: false,
  largeQueryIsActive: false,
  printQueryIsActive: false,
  isNotMobile: not('isMobile').readOnly(),
  isMobile: computed('mobileQueryIsActive', 'userInfo.wantsDesktop', function () {
    if (this.get('userInfo.wantsDesktop')) {
      // Merchant has forced desktop mode via the nav
      return false;
    }
    return this.get('mobileQueryIsActive');
  }).readOnly(),
  isLarge: readOnly('largeQueryIsActive'),
  init(...args) {
    this._super(...args);
    this.queryListenersMap = new Map();

    // 600px is $medium-breakpoint in Glass's standard responsive breakpoints, from which we subtract 1 to get 599
    const mobileBreakpoint = 599;
    const largeBreakpoint = 1024;
    if (matchMedia) {
      this.setupQueryActiveAttribute('mobileQueryIsActive', `screen and (max-width: ${mobileBreakpoint}px)`);
      this.setupQueryActiveAttribute('largeQueryIsActive', `screen and (min-width: ${largeBreakpoint}px)`);
      this.setupQueryActiveAttribute('printQueryIsActive', 'print');
    }
  },
  willDestroy() {
    for (const [query, listener] of this.queryListenersMap.entries()) {
      query.removeListener(listener);
    }
  },
  setupQueryActiveAttribute(queryActiveAttribute, queryString) {
    const query = matchMedia(queryString);
    const setQueryActiveAttribute = e => {
      this.set(queryActiveAttribute, e.matches);
    };

    // Set `fooIsActive` attribute based on current query results
    setQueryActiveAttribute(query);

    // Add listener for future updates
    query.addListener(setQueryActiveAttribute);

    // Save these off for cleanup later
    this.queryListenersMap.set(query, setQueryActiveAttribute);
  }
});